import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth46: ToothDataEntry = {
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M36,324.2c121.9-17.4,161.2,8.1,161.2,8.1l15.1,58.8,3.5,18.2,1.1,15.5-.4,12.5-5.8,18.2-6.3,9.7-9.7,7.4-13.6,4.4-25.4-.9-18.3-2.8-19.8-8.1-38.6,2.1-18.5,1.6-18.5-6.9-10.8-11.8-8.1-15.2-3.7-15.3-1.6-11.1.7-15.2,1.3-17.1,4.7-22.4,8-22.9,3.5-6.9h0Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M138.2,358.6a20.8,20.8 0 1,1 -41.6,0a20.8,20.8 0 1,1 41.6,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M167.9,349.2c-13,1.2-10.5,16.5-10.5,16.5v109.6s3.9,1.3,15.3,1.1c47.5-1,42.2-44.8,43.7-51.9,1.6-7.5-16.5-74.6-16.5-74.6,0,0-19-1.9-32-.7Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M28.1,344.3h0s24.2,2,36.8,2.7c12.6.6,11.2,14.6,11.2,14.6v105.7h-15.1s-16.1-1.2-21.2-7.5c-39.4-31.8-11.7-115.6-11.7-115.6h0Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M31.6,331.1l3.3-7.1s43.4-6.5,76-6c0,0-21.7,85.8-5.7,97.5,21.9,15.9,10.1,49.4,10.1,49.4l-55.4,2.3s-14.4-1.5-20.8-8c-48.3-48.9-7.4-128.1-7.4-128.1h-.1Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M198.3,335.8l-1.1-3.6s-20.8-13.6-86.3-14.2c0,0-21.6,86.8-5.7,97.5,21.9,16.1,10.1,49.4,10.1,49.4,0,0,29.9,12.9,57.4,11.5,47.5-2.3,42.2-44.8,43.7-51.9,1.6-7.5-18.1-88.7-18.1-88.7h0Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M197.2,332.2l-1.5-9.7-1.1-8.3c-67.5-16.7-153.5-4.3-153.5-4.3l-5.1,14.2c119.9-17.2,161.2,8.1,161.2,8.1h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'20.8 410.9 40.4 380.6 50.3 422.8 63.4 371.5 80.7 424.1 96.5 371.5 114.2 423.5 130.5 371.5 148.5 426.7 162.9 374.1 182 426.7 187.8 382.6 212.3 409.6',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'71.9 322.7 85.7 313.6 68.7 304.9 82.6 295.7 66.9 287.6 80.1 278.8 66 271.6 78.8 263.1 62.6 254.8 75.2 246.6 62.2 240 74.8 231.7 60.6 224.5 73.9 215.7 60.6 209 73.9 200.2 61.4 193.7 74.4 185.2 59.3 177.5 74.5 167.5 60 159.9 75 150.1 59.9 142.4 74.7 132.7 57.7 123.9 71.2 114.9 55.3 106.7 71.5 96.2 56.4 88.4 71 78.8 55 70.7 70.4 60.5 54.7 52.4 70.1 39 52.7 34.6 67 17',
				'140.2 23.1 158.3 36.9 152.6 50.3 171.2 52.9 163.4 67.8 177.9 73.4 162.8 86.1 177.4 95.7 162.3 103.5 178.5 114 162.6 122.2 176.1 131.2 159.1 140 173.9 149.7 158.8 157.4 173.8 167.2 159.3 174.8 174.5 184.8 159.4 192.5 172.4 201 159.9 207.5 173.2 216.3 159.9 223 173.2 231.8 159 239 171.6 247.3 158.6 253.9 171.2 262.1 155 270.4 167.8 278.9 153.7 286.1 166.9 294.9 151.2 303 165.1 312.2 148.1 320.9 161.9 330',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'208 192.4 189.3 172.4 171.4 192.8 150 170.5 128.1 192.8 110 169.6 89.9 189 73.2 172.4 59.2 190.4 45.9 170.5 34.3 189.4',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '163.2 183.6 138.2 192.7 118 195.1 87.1 194.8 75.8 192.6 59.1 187 42.1 179.6 28.5 164.9 16 127.2 13.1 114.8 16.1 56.8 22.9 39.6 39.4 23.8 76.2 11.8 103 12.3 140.4 21.3 160 20.8 177.7 24.3 196.2 31.9 208.4 44 214.9 61.7 217.1 75.6 217.5 114.8 214.9 134.4 203.1 152.3 163.2 183.6',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M210.6,49.3l4.2,10.5,1.2,11.4,1.5,13.5-.3,33.2-2.1,16.8-6.3,7.8-42.7-28.7s1.2,1-15.7-11.3c-16.9-12.3,0-21.3,0-21.3l19.4-10.3s40.8-21.6,40.8-21.6Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M21,47.4l-2.2,3.7-2.4,8.1-2.1,13-.4,41.9s4.5,39,14.8,46.6l27.8-41.9,9.6-14.4c11.3-12.8-2.5-20.6-2.5-20.6l-11.2-9.4-31.4-27h0Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M56.5,118.8l-27.8,41.9.6,6.2,12.6,12.9,5.8,1.4,6,3.6,9.6,4.4,9.1,2.7,16.5,3s11.8-44.3,7.7-62.4c-4.1-18.1-5.1-20.3-9.9-22.8-4.8-2.5-30.2,9.1-30.2,9.1h0Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M203.1,152.3l-8.7,7.5-31.2,23.8-24.1,8.4-21.1,3h-29.3c4.4-17.2,10.8-43.1,7.7-62.4-4.3-21.3-17.1-24.5-9.7-22.9,7.4,1.6,13.9,30.1,33.4,13.7,19.5-16.4,46-9.6,46-9.6l42.7,28.7s-5.7,9.8-5.7,9.8Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M210.6,49.3h0l-40.8,21.6c-35,17.4-38.5-5.7-61.7-4.4,0,0,8.3-14,5.3-23.7.7-9,6.1-25.6,6.1-25.6l19.8,3.8,20.7-.2,18.4,3.9,17.4,7.2,9.6,9.7,5.1,7.6h0Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M119.3,17.1h0c-5.3,18.8-6,25.7-6,25.7,1.9,6,.6,12.9-5.3,23.7,0,0-14.8,1-21.5,6.7-6.7,5.7-11.3,5.7-15.9,5.1s-18.3-3.9-18.3-3.9l-31.4-27,1.9-7.8,5.9-5.7,5.2-4.1,5.5-6,8.7-2.6,9.5-3.6,10.6-2.7,8-3.1,26.8.5,16.4,4.9h0Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M169.8,70.9s-2.6,1.3-13.7,7.4-20,13.1-5.8,24c4,2.8,15.8,11.5,15.8,11.5,0,0-22.3-6.3-46,9.6-1.8,1.7-10.4,10.2-20.3,1.2-3.7-3.4-11.2-15.2-13.1-14.9-7.3-1.5-30.2,9.1-30.2,9.1l9.6-14.4c13.7-16.4-13.5-25.7-13.7-30l18.3,3.9c6.4,1,10.1-.5,15.9-5.1,5.8-4.6,3-4.6,21.5-6.7,18.5-2.1,27.3,17.6,53.1,8.1l8.6-3.7Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'15.6 90.3 36.1 121.7 46.5 78 60.1 131.5 78.1 76.5 94.6 131.5 113.1 77.2 130.3 131.5 148.7 73.8 163.9 128.6 183.7 73.8 189.9 119.7 215.4 91.6',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M201.7,197.5s-75.3,43.2-173,8.8l-4-8.4-3.2-7.3-6-15.6-5.1-19.3-3.2-17.2-1.9-12.7-1.1-16.1v-17.2s.6-6.7.6-6.7l1.1-8.1,4.5-8.3,7.8-3.8,19.1.8,10-5.1,4-1.1,4.8-3.5,24.8-12.9,51.3-2.9,22.6-5.4,20.7,4.3,22.3,9.2,4-.9,5.7-.8,5.3.3,3.5,1.6,1.9,3,3.8,7.2,2.1,7.8,1.9,11.1v11s-2.1,17.4-2.1,17.4l-19.7,68.9-2.6,21.8h0Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M131.9,160.5a20.8,20.8 0 1,1 -41.6,0a20.8,20.8 0 1,1 41.6,0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M64.7,52.7h0s2.7,96.6-.7,128.1c0,7.7-5.6,12.7-13.2,12.7l-27.5,1.2-7.5-20-3.2-10.4-4.6-21.8-2.1-23.2-1.8-22.1,1.4-16.4,3.9-9.3,10-6.1,13.6,1.1h8.9s22.8-13.9,22.8-13.9h0Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M201.6,197.4s-30,17.5-76.8,21.1c-20.9-29.5,16.8-138,6.5-176.6l23.3-5.7,8.9,1.5,11.3,3.6,10.2,3.2,12.8,4.8,7.7-1.4,6.8.7h-.1s3.9,1.3,3.9,1.3l4.1,4.5,2.4,7.1,1.9,7.5.9,10.2-.2,18-21.1,70.5-2.3,16.5-.2,13.2h0Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M124.7,218.5s-45.2,5.9-96.1-12.3l-5.4-11.5-7.5-20-3.2-10.4-4.6-21.8-2.1-23.2-1.8-22.1,1.4-16.4,3.9-9.3,10-6.1,13.6,1.1h8.9s36.8-22.1,36.8-22.1h0l20.1-1.3,32.5-1.3c11.3,38.4-27,140.2-6.4,176.7h0Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M201.6,197.3l-.5,18.1c-101.5,43.5-167.6,7-167.6,7l-4.9-16.2c98.4,33.9,173-8.8,173-8.8h0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M201.9,188.1l20-73.4,3.3-17.5.2-18-.9-10.2-1.9-7.5-2.4-7.1-4.1-4.5-3.8-1.3-6.8-.7-7.7,1.4-19-8.8-23.6-4.3v139c0,8.9,5.7,13.8,13.4,13.8s33.4-.9,33.4-.9h-.1Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'6.9 115.3 29.2 149.7 40.2 101.6 54.7 160.1 73.8 100 91.5 160.1 111.4 100.7 129.7 160.1 149.6 96.9 165.6 157 187 96.9 193.6 147.3 220.6 116.6',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'72.3 500.2 56.9 486.8 72.6 478.7 57.2 468.5 73.2 460.4 58.6 450.8 73.7 443 57.5 432.5 73.4 424.3 59.9 415.3 76.9 406.5 62.1 396.8 77.2 389.1 62.2 379.3 76.7 371.7 61.5 361.7 76.6 354 63.6 345.5 76.1 339 62.8 330.2 76.1 323.5 62.8 314.7 77 307.5 64.4 299.2 77.4 292.6 64.8 284.4 81 276.1 68.2 267.6 82.3 260.4 69.1 251.6 84.8 243.5 70.9 234.3 87.9 225.6 74.1 216.5',
				'164.1 209.2 150.3 218.3 167.3 227 153.4 236.2 169.1 244.3 155.9 253.1 170 260.3 157.2 268.8 173.4 277.1 160.8 285.3 173.8 291.9 161.2 300.2 175.4 307.4 162.1 316.2 175.4 322.9 162.1 331.7 174.6 338.2 161.6 346.7 176.7 354.4 161.5 364.4 176 372 161 381.8 176.1 389.5 161.3 399.2 178.3 408 164.8 417 180.7 425.2 164.5 435.7 179.6 443.5 159.4 451.5 171.3 463.4 153.7 467.9 157.7 481 142.4 481 139 495.2',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'32.4 354.6 44.1 373.5 57.3 353.6 71.3 371.6 88.1 355 108.1 374.4 126.2 351.2 148.1 373.5 169.5 351.2 187.5 371.6 206.1 351.6',
			],
		},
	},
};
